import axios from "axios";
import {parseUrl, serializeObject} from "@/utilities/utilities";

console.log(process.env);


class Api {
    apiUrl: string = process.env.API_URL || '//api.link2ticket.com/web';
    channelId;
    eventId;
    reservationId;
    cache = new Map();
    lang = (document.documentElement.lang || 'en-EN').slice(0, 2);

    constructor() {

        let channelEl: any = document.querySelector("#channelId") || {},
            eventEl: any = document.querySelector("#eventId") || {};

        if (!channelEl || !eventEl) console.error('Channel element and/or event element not found');


        let search:any = parseUrl(window.location.search);

        this.channelId = search.channel || channelEl.value;//channelEl.value;
        this.eventId = search.event || eventEl.value;//eventEl.value;

        console.log(`Link2Ticket using event ${this.eventId} and channel ${this.channelId}`);
    }

    post(endpoint, body) {
        return new Promise(async (resolve, reject) => {
            let _body = Object.assign({}, body, {
                Event_id: body.eventId || this.eventId,
                Channel_id: this.channelId,
                Language: this.lang
            });

            let response: any = await axios.post(`${this.apiUrl}/${endpoint}`, _body, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).catch(console.error);

            if (response) {
                resolve(response.data);
            }
        })
    }

    public get(endpoint, body:any = {}):any {
        return new Promise(async (resolve, reject) => {
            let url = `${this.apiUrl}/${endpoint}`;

            if (body) {
                url += `?${serializeObject(Object.assign({}, body, {
                    Event_id: body.Event_id || this.eventId,
                    Channel_id: this.channelId,
                    Language: this.lang
                }))}`
            }

            // let cachedResponse = this.cache.get(url);
            // if(cachedResponse) return resolve(cachedResponse);

            let response = await axios.get(url).catch(response => {
                reject(response.response.data)
            });

            // this.cache.set(url, response);

            if (response) {
                resolve(response.data)
            } else {
                reject(null);
            }
        });
    }
}


export default new Api();
